import { ImgHTMLAttributes } from "react";

export const Img = ({ alt, ...props }: ImgHTMLAttributes<HTMLImageElement>) => {
  return <img {...props} alt={alt || "Image"} />;
};

/**
 * An accessible image component that ensures all images have alt text for screen readers.
 * Wraps the standard HTML img element with a fallback alt text to maintain accessibility
 * standards when alt text is not explicitly provided.
 *
 * @component
 * @example
 * // Basic usage with alt text
 * <Img src="/path/to/image.jpg" alt="Description of the image" />
 *
 * @example
 * // Without alt text (fallback "Image" will be used)
 * <Img src="/path/to/image.jpg" />
 *
 * @example
 * // With additional HTML img attributes
 * <Img
 *   src="/path/to/image.jpg"
 *   alt="Product photo"
 *   width={300}
 *   height={200}
 *   loading="lazy"
 *   className="product-image"
 * />
 *
 * @example
 * // For decorative images (empty alt for screen readers to skip)
 * <Img src="/decorative-pattern.svg" alt="" />
 */
